module.exports = __webpack_public_path__ + "img/icon-tenant.d047dae6.svg";